module.exports = __webpack_public_path__ + "static/img/wing_1110.6578d38.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/wing_1110.jpg
// module id = NFdx
// module chunks = 0